import { __awaiter, __generator } from "tslib";
import Vue from 'vue-ltur';
//@ts-ignore
import Climate from '../Climate/Climate.vue';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
import VueCustomElement from 'vue-custom-element';
import { store } from "ltur-state-engine";
Vue.config.productionTip = false;
var initializeClimate = function () { return __awaiter(void 0, void 0, Promise, function () {
    var lturState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                lturState = store.getState();
                return [4 /*yield*/, new Promise(function (res) {
                        var unsub = store.subscribe(function () {
                            if (Vue.translate !== void 0 && lturState.websiteState.app.translations !== void 0) {
                                unsub();
                                res();
                            }
                        });
                    })];
            case 1:
                _a.sent();
                Vue.use(VueCustomElement);
                // @ts-ignore
                Vue.customElement('c-climate', (new Climate().$options), vueCustomElementOptions);
                return [2 /*return*/];
        }
    });
}); };
export default initializeClimate;
